module.exports = __webpack_public_path__ + "img/14-3.02697d60.png";